import dayjs from "lib/dayjs";
import { createSlice } from "@reduxjs/toolkit";

export const accountSlice = createSlice({
  name: "account",
  initialState: {
    accountExpiration: dayjs.utc().add(2, "day").format(), //"2025-06-06T00:00:00+05:00",
    accountType: "trial", //"individual-k12-yearly-sub",
    autoRenew: false,
    billingHistory: [],
    currentPayment: "",
    gradeLicenseLevel: null,
    groupAdmins: [],
    groupId: null,
    groupName: null,
    groupPreferences: {},
    groupRole: "Administrator",
    init: false,
    isHomeschool: false,
    registrationDate: dayjs.utc().format(),
    subscriptionId: null,
    timeTillExpired: null,
    userReferralCode: null,
    groupReferralCode: null,
    referralCode: null,
    lifeTimeTotal: 0,
    lifetimeCredit: 0,
    availableCredit: 0,
    creditsUsed: 0
  },
  reducers: {
    setAccountExpiration(state, action) {
      const { payload } = action;
      state.accountExpiration = payload;
    },
    setAccountType(state, action) {
      const { payload } = action;
      state.accountType = payload;
    },
    setAutoRenew(state, action) {
      const { payload } = action;
      state.autoRenew = payload;
    },
    setBillingHistory(state, action) {
      const { payload } = action;
      if (!Array.isArray) {
        throw new Error(
          "ACCOUNTSLICE|SETBILLINGHISTORY: Payload must be an array."
        );
      }
      state.billingHistory = payload;
    },
    setCurrentPayment(state, action) {
      const { payload } = action;
      state.currentPayment = payload;
    },
    setGradeLicenseLevel(state, action) {
      const { payload } = action;
      state.gradeLicenseLevel = payload;
    },
    setGroupAdmins(state, action) {
      const { payload } = action;
      state.groupAdmins = payload;
    },
    setGroupId(state, action) {
      const { payload } = action;
      state.groupId = payload;
    },
    setGroupName(state, action) {
      const { payload } = action;
      state.groupName = payload;
    },
    setGroupPreferences(state, action) {
      const { payload } = action;
      state.groupPreferences = payload;
    },
    setGroupRole(state, action) {
      const { payload } = action;
      state.groupRole = payload;
    },
    setInit(state, action) {
      const { payload } = action;
      if (typeof payload === "boolean" && payload != null) {
        state.init = payload;
      } else {
        console.warn("ACCOUNTSLICE:SETINIT: init type must be a Boolean");
      }
    },
    setRegistrationDate(state, action) {
      const { payload } = action;
      state.registrationDate = payload;
    },
    setSubscriptionId(state, action) {
      const { payload } = action;
      state.subscriptionId = payload;
    },
    setTimeTillExpired(state, action) {
      const { payload } = action;
      state.timeTillExpired = payload;
    },
    setIsHomeschool(state, action) {
      const { payload } = action;
      state.isHomeschool = payload;
    },
    setUserReferralCode(state, action) {
      const { payload } = action;
      state.userReferralCode = payload;
    },
    setGroupReferralCode(state, action) {
      const { payload } = action;
      state.groupReferralCode = payload;
    },
    setReferralCode(state, action) {
      const { payload } = action;
      state.referralCode = payload;
    },
    setLifeTimeTotal(state, action) {
      const { payload } = action;
      state.lifeTimeTotal = payload;
    },
    setLifetimeCredit(state, action) {
      const { payload } = action;
      state.lifetimeCredit = payload;
    },
    setAvailableCredit(state, action) {
      const { payload } = action;
      state.availableCredit = payload;
    },
    setCreditsUsed(state, action) {
      const { payload } = action;
      state.creditsUsed = payload;
    },
  },
});

export const {
  setAccountExpiration,
  setAccountType,
  setAutoRenew,
  setBillingHistory,
  setCurrentPayment,
  setGradeLicenseLevel,
  setGroupAdmins,
  setGroupId,
  setGroupName,
  setGroupPreferences,
  setGroupRole,
  setInit,
  setIsHomeschool,
  setRegistrationDate,
  setSubscriptionId,
  setTimeTillExpired,
  setUserReferralCode,
  setGroupReferralCode,
  setReferralCode,
  setLifeTimeTotal,
  setLifetimeCredit,
  setAvailableCredit,
  setCreditsUsed,
} = accountSlice.actions;

export const accountReducer = accountSlice.reducer;
